export const notes = {
  title: 'Jegyzetek',
  subtitle: 'Sticky Notes',
  
  // Gombok és műveletek
  actions: {
    createNote: 'Új jegyzet',
    editNote: 'Szerkesztés',
    deleteNote: 'Törlés',
    saveNote: 'Mentés',
    cancelEdit: 'Mégse',
    archiveNote: 'Archiválás',
    restoreNote: 'Visszaállítás',
    changeColor: 'Szín változtatása',
    moveNote: 'Áthelyezés'
  },

  // Állapotok
  status: {
    empty: 'Üres jegyzet...',
    loading: 'Jegyzetek betöltése...',
    noNotes: 'Még nincsenek jegyzeteid',
    noResults: 'Nincs találat',
    archived: 'Archiválva',
    created: 'Jegyzet létrehozva',
    updated: 'Jegyzet frissítve',
    deleted: 'Jegyzet törölve'
  },

  // Keresés és szűrés
  search: {
    placeholder: 'Keresés a jegyzetekben...',
    noResults: 'Nincs jegyzet a keresésre',
    resultsCount: '{count} jegyzet találva'
  },

  // Színek
  colors: {
    yellow: 'Sárga',
    blue: 'Kék',
    green: 'Zöld',
    pink: 'Rózsaszín',
    purple: 'Lila',
    orange: 'Narancs'
  },

  // Prioritások
  priority: {
    low: 'Alacsony',
    medium: 'Közepes',
    high: 'Magas'
  },

  // Tippek és súgó
  tips: {
    title: 'Tippek:',
    drag: 'Húzd a jegyzeteket az áthelyezéshez',
    edit: 'Kattints a ceruza ikonra a szerkesztéshez',
    menu: 'Használd a három pont menüt a színváltáshoz',
    create: 'Kattints az "Új jegyzet" gombra a első jegyzeted létrehozásához!'
  },

  // Hibaüzenetek
  errors: {
    loadFailed: 'Nem sikerült betölteni a jegyzeteket',
    createFailed: 'Nem sikerült létrehozni a jegyzetet',
    updateFailed: 'Nem sikerült frissíteni a jegyzetet',
    deleteFailed: 'Nem sikerült törölni a jegyzetet',
    archiveFailed: 'Nem sikerült archiválni a jegyzetet'
  },

  // Menük
  menu: {
    archive: 'Archív',
    viewArchived: 'Archivált jegyzetek megtekintése',
    backToNotes: 'Vissza a jegyzetekhez'
  },

  // Tag-ek
  tags: {
    add: 'Tag hozzáadása',
    remove: 'Tag eltávolítása',
    placeholder: 'Tag neve...',
    all: 'Minden tag',
    none: 'Tag nélkül'
  },

  // Csoportosítás
  grouping: {
    none: 'Csoportosítás nélkül',
    byTag: 'Tag szerint',
    byColor: 'Szín szerint',
    byDate: 'Dátum szerint'
  },

  // Placeholderek
  placeholders: {
    noteContent: 'Írj ide valamit...',
    searchNotes: 'Keresés a jegyzetekben...',
    clickToEdit: 'Kattints ide a szerkesztéshez...'
  }
};
